module.exports = __webpack_public_path__ + "static/img/img_1.943df758.jpg";